/* eslint-disable @typescript-eslint/no-unused-vars */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Liquidation } from '../_models/liquidation.model';

@Injectable()
export class LiquidationService {
  constructor(private http: HttpClient) {}

  getAllLiquidations(): Observable<Liquidation[]> {
    return this.http.get<Liquidation[]>('api/liquidations/');
  }

  findLiquidations(
    queryParams: QueryParamsModel
  ): Observable<QueryResultsModel> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<QueryResultsModel>(
      'api/liquidations/find/',
      queryParams,
      { headers: httpHeaders }
    );
  }

  private handleError<T>(operation = 'operation', result?: any) {
    return (error: any): Observable<any> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result);
    };
  }
}
